import config from "../config/config.js";
import { getHeaders, handleResponse } from "./utils";

/**
 * Who sees the VIEW / VISION Dashboard. The Dev/Demo build (enableDashboard)
 * shows it to everyone. Production shows it only to system admins and to
 * multi-seat (enterprise / VIEW-VISION) companies, so $25 single-user
 * subscribers never get a Dashboard button that leads to an empty page.
 */
export function isDashboardEnabled(accountProfile, companyProfile) {
  if (config.enableDashboard) return true;
  if (accountProfile && accountProfile.system_admin_role) return true;
  return Boolean(companyProfile && Number(companyProfile.seat_limit) > 1);
}

/**
 * VIEW / VISION dashboard data.
 *
 * company/dashboard-data returns the signed-in user's OWN company rollup in one
 * call (login required; no company id, so no one can read another company):
 *   { company, asOf, people[], brokerCompanies[], brokerLos[], loans[] }
 * People carry role/region/product/reportsToId (the retail + wholesale org
 * tree); loans carry stage/dates/amount/credit/type and ownerUserId (retail LO)
 * or aeUserId (wholesale AE). The dashboard computes every rollup client-side
 * from this single payload, scoped to the signed-in person.
 */
const DashboardService = {
  async getDashboardData() {
    const headers = getHeaders();
    const response = await fetch(
      config.serviceHost + "company/dashboard-data",
      { method: "GET", headers }
    );
    return handleResponse(response);
  }
};

export default DashboardService;
